import React, { useEffect } from "react";
import { RevolvingDot } from "react-loader-spinner";
import './loader.css';

const Loader = ({ isLoading }) => {
  useEffect(() => {
    if (isLoading) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    // پاک کردن تغییرات در هنگام حذف کامپوننت
    return () => document.body.classList.remove("no-scroll");
  }, [isLoading]);

  if (!isLoading) return null;

  return (
    <div className="dot-loader">
      <RevolvingDot
        visible={true}
        height="50"
        width="50"
        color="#0033CC"
        animationDuration="0.5"
        ariaLabel="revolving-dot-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  );
};

export default Loader;
